const technologies = [
    {
        type: "Programming Language",
        technologiesList: ["Java", "JavaScript", "TypeScipts", "Python"]
    },
    {
        type: "Front-ent Technologies",
        technologiesList: ["React Native", "Expo", "Next.js", "React.js", "React Hooks", "Redux", "Angular", "Ngrx", "RxJS", "Vue.js", "Boostrap 5", "Material UI", "SweetAlert", "Apollo client"]
    },
    {
        type: "Back-ent Technologies",
        technologiesList: ["Spring Boot", "Spring Data", "Spring JPA", "JWT", "Spring Security", "Hibernate", "Express.js", "Node.js", "GraphQL", "RESTful API", "Postman", "Axios", "Firebase"]
    },
    {
        type: "Database Design and Management",
        technologiesList: ["MySQL", "PostgreSQL", "H2 Database", "MongoDB", "Mongoose", "MongoDB Atlas", "MongoDB Compass"]
    },
    {
        type: "DevOps",
        technologiesList: ["Docker", "Kubernetes", "JUnit", "Sonar", "Jenkins", "ArgoCD", "AWS", "Netflix Eureka", "MicroServices", "Github"]
    },
    {
        type: "Web Hosting",
        technologiesList: ["Railway", "Microsoft Azure", "Heroku", "Render (web hosting)"]
    }
];
export default technologies;